import React,{useState}from'react';
import{useNavigate}from'react-router-dom';
import Layout from'../components/layout/Layout';
import api from'../services/api';

const BLOOD_GROUPS=['A+','A-','B+','B-','AB+','AB-','O+','O-'];
const DONATE_TYPES=['WHOLE_BLOOD','PLATELETS','PLASMA','DOUBLE_RED'];

export default function DonorRegistrationPage(){
  const nav=useNavigate();
  const [form,setForm]=useState({firstName:'',lastName:'',dob:'',gender:'MALE',bloodGroup:'',mobile:'',email:'',address:'',city:'',weight:'',
    hemoglobin:'',bp:'',pulse:'',temperature:'',donationType:'WHOLE_BLOOD',lastDonationDate:'',donorType:'VOLUNTARY',
    knownDiseases:'',medications:'',tattooPiercing:false,recentSurgery:false,recentIllness:false,alcoholLast24h:false,
      donorNumber:'',
      dateOfBirth:'',
      rhType:'POSITIVE',
      aadhaarNumber:'',
      occupation:'',
      donorStatus:'ACTIVE',
      totalDonations:'0',
      nextEligibleDate:'',
      lastHbLevel:'',
      bloodPressure:'',
      pulseRate:'',
      screeningDate:'',
      previousDonationDate:'',
      hasSurgeryHistory:false,
      hasInfectionHistory:false,
      hasMedicationHistory:false,
      isPregnant:false,
      medicalNotes:'',
      tattooOrPiercing:false,
      tattooDate:'',
      sexualRiskHistory:false,
      travelHistory:'',
      bloodBagNumber:''
    });
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const f=(k:string,v:any)=>setForm(x=>({...x,[k]:v}));

  const submit=async()=>{
    if(!form.firstName||!form.bloodGroup||!form.mobile){setMsg('Name, blood group and mobile are required');return;}
    setSaving(true);
    try{
      await api.registerDonor?.(form);
      nav('/bloodbank');
    }catch(e:any){setMsg('Error: '+(e.response?.data?.message||'failed'));}
    setSaving(false);
  };

  const eligible=!form.tattooPiercing&&!form.recentSurgery&&!form.recentIllness&&!form.alcoholLast24h&&
    (+form.weight>=50)&&(+form.hemoglobin>=12.5)&&form.bloodGroup;

  return(
    <Layout>
      <div className="p-6 max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div><h1 className="text-2xl font-bold text-gray-900">Donor Registration</h1><p className="text-gray-500">Register a new blood donor after screening</p></div>
          <button onClick={()=>nav('/bloodbank')} className="border px-4 py-2 rounded-lg hover:bg-gray-50 text-sm">← Blood Bank</button>
        </div>
        {msg&&<div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg">{msg}</div>}

        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 space-y-6">
            {/* Personal Info */}
            <div className="bg-white rounded-xl shadow-sm border p-5">
              <h3 className="font-bold text-gray-800 mb-4">Donor Information</h3>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium mb-1">First Name *</label><input value={form.firstName} onChange={e=>f('firstName',e.target.value)} className="w-full border rounded-lg p-2"/></div>
                <div><label className="block text-sm font-medium mb-1">Last Name</label><input value={form.lastName} onChange={e=>f('lastName',e.target.value)} className="w-full border rounded-lg p-2"/></div>
                <div><label className="block text-sm font-medium mb-1">Date of Birth</label><input type="date" value={form.dob} onChange={e=>f('dob',e.target.value)} className="w-full border rounded-lg p-2"/></div>
                <div><label className="block text-sm font-medium mb-1">Gender</label><select value={form.gender} onChange={e=>f('gender',e.target.value)} className="w-full border rounded-lg p-2">{['MALE','FEMALE'].map(g=><option key={g}>{g}</option>)}</select></div>
                <div><label className="block text-sm font-medium mb-1">Blood Group *</label><select value={form.bloodGroup} onChange={e=>f('bloodGroup',e.target.value)} className="w-full border rounded-lg p-2"><option value="">Select</option>{BLOOD_GROUPS.map(g=><option key={g}>{g}</option>)}</select></div>
                <div><label className="block text-sm font-medium mb-1">Donor Type</label><select value={form.donorType} onChange={e=>f('donorType',e.target.value)} className="w-full border rounded-lg p-2">{['VOLUNTARY','REPLACEMENT','AUTOLOGOUS','DIRECTED'].map(t=><option key={t}>{t}</option>)}</select></div>
                <div><label className="block text-sm font-medium mb-1">Mobile *</label><input value={form.mobile} onChange={e=>f('mobile',e.target.value)} className="w-full border rounded-lg p-2"/></div>
                <div><label className="block text-sm font-medium mb-1">Email</label><input type="email" value={form.email} onChange={e=>f('email',e.target.value)} className="w-full border rounded-lg p-2"/></div>
                <div className="col-span-2"><label className="block text-sm font-medium mb-1">Address</label><input value={form.address} onChange={e=>f('address',e.target.value)} className="w-full border rounded-lg p-2"/></div>
              </div>
            </div>

            {/* Screening Vitals */}
            <div className="bg-white rounded-xl shadow-sm border p-5">
              <h3 className="font-bold text-gray-800 mb-4">Pre-Donation Screening</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                {[['Weight (kg)*','weight'],['Hemoglobin (g/dL)*','hemoglobin'],['BP (mmHg)','bp'],['Pulse (bpm)','pulse'],['Temperature (°F)','temperature']].map(([l,k])=>(
                  <div key={k}><label className="block text-sm font-medium mb-1">{l}</label><input type="number" step="0.1" value={(form as any)[k]} onChange={e=>f(k,e.target.value)} className={`w-full border rounded-lg p-2 ${k==='weight'&&+form.weight>0&&+form.weight<50?'border-red-400':k==='hemoglobin'&&+form.hemoglobin>0&&+form.hemoglobin<12.5?'border-red-400':''}`}/></div>
                ))}
              </div>
              <div><label className="block text-sm font-medium mb-1">Donation Type</label>
                <div className="grid grid-cols-4 gap-2">{DONATE_TYPES.map(t=><button key={t} onClick={()=>f('donationType',t)} className={`p-2 rounded-lg border text-sm font-medium ${form.donationType===t?'bg-red-600 text-white border-red-600':'hover:border-red-300'}`}>{t.replace('_',' ')}</button>)}</div>
              </div>
              <div className="mt-4"><label className="block text-sm font-medium mb-1">Last Donation Date</label><input type="date" value={form.lastDonationDate} onChange={e=>f('lastDonationDate',e.target.value)} className="w-full border rounded-lg p-2 max-w-xs"/></div>
            </div>

            {/* Deferrals */}
            <div className="bg-white rounded-xl shadow-sm border p-5">
              <h3 className="font-bold text-gray-800 mb-4">Deferral Screening</h3>
              <div className="space-y-3">
                {[['Tattoo or piercing in last 6 months','tattooPiercing'],['Surgery in last 6 months','recentSurgery'],
                  ['Illness/fever in last 14 days','recentIllness'],['Alcohol consumption in last 24 hours','alcoholLast24h']].map(([l,k])=>(
                  <label key={k} className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer ${(form as any)[k]?'bg-red-50 border-red-300':''}`}>
                    <input type="checkbox" checked={(form as any)[k]} onChange={e=>f(k,e.target.checked)} className="w-4 h-4 rounded"/>
                    <span className="text-sm">{l}</span>
                    {(form as any)[k]&&<span className="ml-auto text-xs text-red-600 font-semibold">DEFER</span>}
                  </label>
                ))}
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium mb-1">Known Diseases</label><textarea value={form.knownDiseases} onChange={e=>f('knownDiseases',e.target.value)} className="w-full border rounded-lg p-2 text-sm" rows={2} placeholder="HIV, Hepatitis, Malaria history…"/></div>
                <div><label className="block text-sm font-medium mb-1">Current Medications</label><textarea value={form.medications} onChange={e=>f('medications',e.target.value)} className="w-full border rounded-lg p-2 text-sm" rows={2} placeholder="Any ongoing medications…"/></div>
              </div>
            </div>
          </div>

          {/* Eligibility Panel */}
          <div>
            <div className={`sticky top-6 rounded-xl border p-5 ${eligible?'bg-green-50 border-green-300':'bg-red-50 border-red-300'}`}>
              <div className="text-center mb-4">
                <div className="text-5xl mb-2">{eligible?'✅':'❌'}</div>
                <h3 className={`text-xl font-bold ${eligible?'text-green-700':'text-red-700'}`}>{eligible?'ELIGIBLE':'NOT ELIGIBLE'}</h3>
                <p className="text-sm text-gray-600 mt-1">for donation today</p>
              </div>
              <div className="space-y-2 text-sm">
                <div className={`flex items-center gap-2 ${+form.weight>=50?'text-green-700':'text-red-600'}`}>
                  {+form.weight>=50?'✓':'✗'} Weight ≥ 50 kg {form.weight?`(${form.weight}kg)`:''}
                </div>
                <div className={`flex items-center gap-2 ${+form.hemoglobin>=12.5?'text-green-700':'text-red-600'}`}>
                  {+form.hemoglobin>=12.5?'✓':'✗'} Hemoglobin ≥ 12.5 {form.hemoglobin?`(${form.hemoglobin})`:''}
                </div>
                <div className={`flex items-center gap-2 ${form.bloodGroup?'text-green-700':'text-red-600'}`}>
                  {form.bloodGroup?'✓':'✗'} Blood group selected
                </div>
                <div className={`flex items-center gap-2 ${!form.tattooPiercing?'text-green-700':'text-red-600'}`}>
                  {!form.tattooPiercing?'✓':'✗'} No recent tattoo/piercing
                </div>
                <div className={`flex items-center gap-2 ${!form.recentSurgery?'text-green-700':'text-red-600'}`}>
                  {!form.recentSurgery?'✓':'✗'} No recent surgery
                </div>
                <div className={`flex items-center gap-2 ${!form.recentIllness?'text-green-700':'text-red-600'}`}>
                  {!form.recentIllness?'✓':'✗'} No recent illness
                </div>
                <div className={`flex items-center gap-2 ${!form.alcoholLast24h?'text-green-700':'text-red-600'}`}>
                  {!form.alcoholLast24h?'✓':'✗'} No alcohol last 24h
                </div>
              </div>
              <button onClick={submit} disabled={!eligible||saving} className="w-full mt-6 py-3 bg-red-600 text-white rounded-xl font-bold hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed">
                {saving?'Registering…':'🩸 Register Donor'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
